<template>
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="22.5" stroke-width="3"/>
    <path v-if="!isPlaying" d="M30.4114 21.835C32.078 22.7972 32.078 25.2028 30.4114 26.1651L22.6694 30.6349C21.0028 31.5972 18.9194 30.3943 18.9194 28.4698L18.9194 19.5302C18.9194 17.6057 21.0028 16.4029 22.6694 17.3652L30.4114 21.835Z" stroke-width="3"/>
    <g v-else>
      <path d="M16 17.5C16 16.1193 17.1193 15 18.5 15C19.8807 15 21 16.1193 21 17.5V29.5C21 30.8807 19.8807 32 18.5 32C17.1193 32 16 30.8807 16 29.5V17.5Z" />
      <path d="M27 17.5C27 16.1193 28.1193 15 29.5 15C30.8807 15 32 16.1193 32 17.5V29.5C32 30.8807 30.8807 32 29.5 32C28.1193 32 27 30.8807 27 29.5V17.5Z" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'play-icon',
  props: {
    isPlaying: Boolean
  }
}
</script>

<style lang="scss" scoped>
svg {
  width: inherit;
  height: inherit;

  & > circle, & > path {
    stroke: $player-footer-icons-color;
  }

  & > g > path {
    fill: $player-footer-icons-color;
  }
}
</style>
